import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import * as Sentry from '@sentry/angular';
import { environment } from './environments/environment';

Sentry.init({
  dsn: 'https://c31d32ba0b9296c33c82fd9f840fae96@o4509605877317632.ingest.de.sentry.io/4509606024904784',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  environment: environment.production ? 'production' : 'development',
  release: environment.sentryRelease,
});

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
